import React, { useState } from "react";
import ModalContainer from "../../common/ModalContainer";
import CommonFreeTextInput from "../../common/inputs/CommonFreeTextInput";
import useInvoiceApi from "../../../hooks/useInvoiceApi";
import CommonPhoneNumberInput from "../../common/CommonPhoneNumberInput";

const initData = {
  firstName: "",
  middleName: "",
  lastName: "",
  email: "",
  phoneNumber: "234-",
  address: "",
};

export const CreateCustomerModal = ({ setOpen, open, edit, customer }) => {
  const { createCustomer, updateCustomer } = useInvoiceApi();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(
    edit
      ? {
          firstName: customer?.firstName,
          middleName: customer?.middleName,
          lastName: customer?.lastName,
          email: customer?.email,
          phoneNumber: customer?.phone,
          address: customer?.address,
        }
      : initData
  );

  const [validation, setValidation] = useState({
    focus: {
      firstName: false,
      middleName: false,
      lastName: false,
      email: false,
      phoneNumber: false,
      address: false,
    },
    error: {
      firstName: false,
      middleName: false,
      lastName: false,
      email: false,
      phoneNumber: false,
      address: false,
    },
  });

  const handleFocus = (field) => {
    setValidation((prev) => ({
      ...prev,
      focus: { ...prev.focus, [field]: true },
      error: { ...prev.error, [field]: false },
    }));
  };

  const handleBlur = (field) => {
    if (!data?.[field]) {
      setValidation((prev) => ({
        ...prev,
        error: { ...prev.error, [field]: true },
      }));
    } else if (data?.email && !isValidEmail(data?.email)) {
      setValidation((prev) => ({
        ...prev,
        error: { ...prev.error, email: true },
      }));
    }
  };

  const isValidEmail = (email) =>
    typeof email === "string" && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const dataInvalid =
    !data.firstName ||
    !data.lastName ||
    !data.address ||
    !data.email ||
    !isValidEmail(data.email);

  const handleClose = () => setOpen(false);
  const handleConfirm = async () => {
    if (edit) {
      await updateCustomer({
        data,
        setLoading,
        callback: () => {
          setOpen(false);
        },
        id: customer?._id,
      });
      return;
    }
    await createCustomer({
      data,
      setLoading,
      callback: () => {
        setOpen(false);
        setData(initData);
      },
    });
  };

  const Footer = () => (
    <div className="w-full flex flex-col static bottom-0">
      <hr className="border-gray-300 my-3 mb-6" />
      <div className="flex gap-4 items-center">
        <button
          className="flex items-center justify-center text-black px-10 py-4 rounded-lg text-xs sm:text-lg"
          onClick={handleClose}
        >
          <span>Close</span>
        </button>
        <button
          className="bg-primary1 disabled:bg-gray-500 disabled:cursor-not-allowed flex items-center justify-center text-white w-full py-4 rounded-lg text-xs sm:text-lg"
          onClick={handleConfirm}
          disabled={dataInvalid}
        >
          {loading ? (
            <div className="buttonLoader" />
          ) : (
            <span>{edit ? "Update" : "Confirm"}</span>
          )}
        </button>
      </div>
    </div>
  );

  return (
    <ModalContainer
      open={open}
      setOpen={setOpen}
      secondary
      padding="px-4 py-6"
      title="Create customer"
      subTitle="Enter details of your customer"
      footer={<Footer />}
    >
      <div className="w-full flex flex-col">
        <div className="relative overflow-x-auto flex flex-col scroll-hide px-4">
          <div className="w-full gap-3 flex mt-3">
            <CommonFreeTextInput
              label="First name"
              value={data.firstName}
              onChange={(val) => setData({ ...data, firstName: val })}
              onFocus={() => handleFocus("firstName")}
              onBlur={() => handleBlur("firstName")}
              error={validation.error.firstName}
            />
            <CommonFreeTextInput
              label="Middle name (Optional)"
              value={data.middleName}
              onChange={(val) => setData({ ...data, middleName: val })}
            />
            <CommonFreeTextInput
              label="Last name"
              value={data.lastName}
              onChange={(val) => setData({ ...data, lastName: val })}
              onFocus={() => handleFocus("lastName")}
              onBlur={() => handleBlur("lastName")}
              error={validation.error.lastName}
            />
          </div>
          <div className="w-full gap-3 flex mt-3">
            <CommonFreeTextInput
              label="Email"
              //   placeholder="e.g Visa Handling"
              value={data.email}
              onChange={(val) => setData({ ...data, email: val })}
              onFocus={() => handleFocus("email")}
              onBlur={() => handleBlur("email")}
              error={validation.error.email}
              forceError
            />
          </div>
          <div className="w-full gap-3 flex mt-3">
            <CommonFreeTextInput
              label="Address"
              //   placeholder="e.g Visa Handling"
              value={data.address}
              onChange={(val) => setData({ ...data, address: val })}
              onFocus={() => handleFocus("address")}
              onBlur={() => handleBlur("address")}
              error={validation.error.address}
            />
          </div>
          <div className="w-full gap-1 flex flex-col mt-3">
            <span className={`block text-sm text-gray-600`}>Phone number</span>
            <CommonPhoneNumberInput
              className="w-full"
              countryCode={data?.phoneNumber?.split("-")?.at(0)}
              phoneNumber={data?.phoneNumber?.split("-")?.at(1)}
              onChange={(val) =>
                setData({
                  ...data,
                  phoneNumber: `${val?.countryCode}-${val?.phoneNumber}`,
                })
              }
              onFocus={() => handleFocus("phoneNumber")}
              onBlur={() => handleBlur("phoneNumber")}
              error={validation.error.phoneNumber}
            />
          </div>

          <div className="h-20"></div>
        </div>
      </div>
    </ModalContainer>
  );
};
